import { useRef, useState } from "react";
import { Play, Volume2, VolumeX } from "lucide-react";

export const FilmPlayer = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <div
      className="relative mx-auto aspect-[9/16] w-full max-w-[300px] overflow-hidden border border-[#A58343]/30 bg-[#262019]"
      data-testid="film-player"
    >
      <video
        ref={videoRef}
        poster="/assets/brand/merakee-film-poster.jpg"
        muted={muted}
        loop
        playsInline
        preload="metadata"
        onClick={togglePlay}
        onPause={() => setPlaying(false)}
        onPlay={() => setPlaying(true)}
        className="h-full w-full cursor-pointer object-contain"
        data-testid="film-video"
      >
        <source src="/assets/brand/merakee-film.webm" type="video/webm" />
        <source src="/assets/brand/merakee-film.mp4" type="video/mp4" />
      </video>
      {!playing && (
        <button
          onClick={togglePlay}
          data-testid="film-play-button"
          aria-label="Play the Merakee film"
          className="absolute inset-0 flex items-center justify-center bg-[#262019]/15"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-full border border-white/70 bg-[#FAF7F1]/20 text-white backdrop-blur-md transition-transform duration-300 hover:scale-110">
            <Play size={22} strokeWidth={1.5} className="ml-1" />
          </span>
        </button>
      )}
      {playing && (
        <button
          onClick={toggleMute}
          data-testid="film-sound-toggle"
          aria-label={muted ? "Turn sound on" : "Turn sound off"}
          className="absolute bottom-4 right-4 flex h-10 w-10 items-center justify-center rounded-full border border-white/50 bg-[#262019]/40 text-white backdrop-blur-md transition-colors duration-300 hover:bg-[#262019]/60"
        >
          {muted ? <VolumeX size={16} strokeWidth={1.5} /> : <Volume2 size={16} strokeWidth={1.5} />}
        </button>
      )}
      {playing && muted && (
        <p className="pointer-events-none absolute bottom-4 left-4 text-[10px] uppercase tracking-[0.25em] text-white/80">
          Tap for sound
        </p>
      )}
    </div>
  );
};
